export default "__VITE_ASSET__BtLGaisn__"